"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConvertFormat = exports.convertFormat = exports.covertCalc = exports.getCurrencyRate = void 0;

var _react = require("react");

var _request = _interopRequireDefault(require("../service/request"));

var _CurrencyContext = _interopRequireDefault(require("./CurrencyContext"));

var _index = _interopRequireDefault(require("./index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * 接口获取货币汇率
 */
var getCurrencyRate = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
    var _yield$axios$get, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _request["default"].get('/api/trade/currency/rate/list', options);

          case 3:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            return _context.abrupt("return", data === null || data === void 0 ? void 0 : data.rates);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            console.error('获取汇率数据失败', _context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function getCurrencyRate(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * 换算方法
 * @param value
 * @param from
 * @param to
 */


exports.getCurrencyRate = getCurrencyRate;

var covertCalc = function covertCalc(value, from, to) {
  var _dataSource$to, _dataSource$from;

  var dataSource = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (from === to) {
    return value;
  }

  return value * ((_dataSource$to = dataSource === null || dataSource === void 0 ? void 0 : dataSource[to]) !== null && _dataSource$to !== void 0 ? _dataSource$to : 1) / ((_dataSource$from = dataSource === null || dataSource === void 0 ? void 0 : dataSource[from]) !== null && _dataSource$from !== void 0 ? _dataSource$from : 1);
};
/**
 * 换算格式化方法
 * @param value
 * @param options
 */


exports.covertCalc = covertCalc;

var convertFormat = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(value, options) {
    var from, to, platform, lang, requestConfig, data, rst;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            from = options.from, to = options.to, platform = options.platform, lang = options.lang, requestConfig = options.requestConfig;
            _context2.next = 3;
            return getCurrencyRate(requestConfig);

          case 3:
            data = _context2.sent;
            rst = covertCalc(value, from, to, data);

            if (!platform) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("return", _index["default"].formatByPlatform(rst, platform));

          case 7:
            return _context2.abrupt("return", _index["default"].format(rst, {
              code: to,
              lang: lang
            }));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function convertFormat(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.convertFormat = convertFormat;

var useConvertFormat = function useConvertFormat() {
  var context = (0, _react.useContext)(_CurrencyContext["default"]);
  var lang = context.lang,
      fromCurrencyCode = context.fromCurrencyCode,
      rateData = context.rateData,
      _context$toCurrencyCo = context.toCurrencyCode,
      toCurrencyCode = _context$toCurrencyCo === void 0 ? '' : _context$toCurrencyCo;
  var covert = (0, _react.useMemo)(function () {
    return function (value) {
      return covertCalc(value, fromCurrencyCode, toCurrencyCode, rateData !== null && rateData !== void 0 ? rateData : {});
    };
  }, [rateData, fromCurrencyCode, toCurrencyCode]);
  var convertFormat = (0, _react.useMemo)(function () {
    return function (value) {
      return _index["default"].format(covertCalc(value, fromCurrencyCode, toCurrencyCode, rateData !== null && rateData !== void 0 ? rateData : {}), {
        code: toCurrencyCode,
        lang: lang
      });
    };
  }, [fromCurrencyCode, toCurrencyCode, rateData, lang]);

  var _currencyUtils$useCur = _index["default"].useCurrency(toCurrencyCode),
      digit = _currencyUtils$useCur.digit,
      symbol = _currencyUtils$useCur.symbol,
      decimalSymbol = _currencyUtils$useCur.decimalSymbol,
      country = _currencyUtils$useCur.country;

  return {
    /**
     * 换算后并格式化, 返回值带单位
     */
    convertFormat: convertFormat,

    /**
     * 进行汇率换算, 返回换算后的数值
     */
    covert: covert,
    digit: digit,
    symbol: symbol,
    decimalSymbol: decimalSymbol,
    country: country
  };
};

exports.useConvertFormat = useConvertFormat;